import React from "react";
import { formatDateFromStraightToComplex } from "../../../common-data/Converts";

const ConsumedPlanStatus = ({ allDatas }) => {
  const { allPTsessionsDetails, allPTSessionDetailArray } = allDatas || {};
  const nSessions = allPTsessionsDetails?.n_session || 0;
  const updatedPTSessionDetailArray = [...(allPTSessionDetailArray || [])];
  const additionalObjects = nSessions - updatedPTSessionDetailArray.length;
  if (additionalObjects > 0) {
    updatedPTSessionDetailArray.push(...Array(additionalObjects).fill({}));
  }

  const completedSession = allPTSessionDetailArray?.length;

  return (
    <div className="plan-consumtion">
      <div className="flexBetween">
        <h3 className="plan-usage-heading">PT Plan Usage</h3>
        <div className="flexEnd">
          <div className="flexBox">
            <div className="colorBox green"></div>
            <span className="label">Attended</span>
          </div>
          {/* <div className="flexBox">
            <div className="colorBox red"></div>
            <span className="label">Missed</span>
          </div> */}
          <div className="flexBox">
            <span className="label-big">
              {completedSession} / <b>{nSessions}</b>
            </span>
          </div>
        </div>
      </div>

      <div className="all-session-details-container">
        {updatedPTSessionDetailArray?.map((item, index) => {
          const sessionNo = parseInt(item?.session_no || 0);
          const isCompleted = sessionNo === index + 1;

          return (
            <div
              key={index}
              className={`session-detail-box`}
              style={{
                background: isCompleted ? "#09BA09" : "#ECECEC",
              }}
            >
              <div className="session-detail-heading">
                <p
                  className="session-name"
                  style={{
                    color: isCompleted ? "#FFF" : "#807E7E",
                  }}
                >
                  S{index + 1}
                </p>
              </div>
              {isCompleted && (
                <div className="session-details">
                  <span className="info-value">
                    {item?.date
                      ? formatDateFromStraightToComplex(item.date)
                      : "-"}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ConsumedPlanStatus;
